$(document).ready(function () {
    const STORAGE_KEY = 'orders_history';
  
    async function loadOrdersHistory() {
        let ordersHashes;
        try {
            const storedData = localStorage.getItem(STORAGE_KEY);
            ordersHashes = storedData ? JSON.parse(storedData) : [];
        } catch (e) {
            ordersHashes = [];
        }
        const $container = $('.orders');
  
        $container.find('#order_banner').nextAll().remove();
  
        for (const hash of ordersHashes) {
            try {
                const orderData = await fetchOrderData(hash);
                if (orderData) {
                    createOrderBanner(orderData, hash);
                }
            } catch (error) {
                console.error('Ошибка загрузки заказа:', hash, error);
            }
        }
    }
  
    async function fetchOrderData(hash) {
        try {
            const response = await fetch(`/zakaz/api/${hash}`);
            if (!response.ok) throw new Error('Ошибка сети');
            return await response.json();
        } catch (error) {
            console.error('Не удалось загрузить данные заказа:', error);
            return null;
        }
    }
    function createOrderBanner(orderData, hash) {

        const SKIP_STATUSES = [
            "Ожидает оплаты",
            "Отменен сотрудником",
            "Отменен клиентом",
            "Получен"
        ];

        if (SKIP_STATUSES.includes(orderData.status_display)) {
            return; 
        }

        const isCanPickup = orderData.status_display === "Можно получать";
        
        const $banner = $(`
        <section class="order_banner">
        <a href="/zakaz/${hash}" class="order-link ${isCanPickup ? 'can-pickup' : ''}">
            Заказ ${orderData.id} ${orderData.status_display}
        </a>
        </section>
        `);

        $('.orders')
            .removeClass('invisible') 
            .append($banner);
    }
    loadOrdersHistory();
  
  });
  